import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import BaseButton from '../Buttons/BaseButton';
import BaseDialog from './BaseDialog';

const BrebAmountDialog = ({ open, onClose, minimumAmount, maximumAmount }) => {
  const classes = useStyles();

  const renderContent = () => {
    return (
      <Typography className={classes.text}>
        El pago con Bre-B solo está disponible para montos entre{' '}
        <strong>{minimumAmount}</strong> y <strong>{maximumAmount}</strong> de
        pesos.
      </Typography>
    );
  };

  const renderActions = () => {
    return <BaseButton onClick={onClose}>Aceptar</BaseButton>;
  };

  return (
    <BaseDialog
      id="payments_breb_invalid_amount_dialog"
      open={open}
      handleClose={onClose}
      title="Monto no disponible"
      content={renderContent}
      actions={renderActions}
      contentSize="small"
    />
  );
};

const useStyles = makeStyles(theme => ({
  text: {
    padding: theme.spacing(2),
    textAlign: 'center',
    fontSize: '16px'
  }
}));

export default BrebAmountDialog;
